import Pagination from "./Pagination";

const PaginationFull = ({
  totalRecords = 0,
  itemsPerPage = 30,
  onPageChange,
  currentPage,
  totalPages
}) => {
  return (
    <Pagination
      totalPages={totalPages}
      totalItems={totalRecords}
      currentPage={currentPage}
      itemsPerPage={itemsPerPage}
      onPageChange={onPageChange}
    />
  );
};

export default PaginationFull;
